import React, { useState, useEffect } from 'react';
import '../../assets/styles/home.scss';
import { Colors } from '../../constants';
import { useTranslation } from 'react-i18next';

const Error = (props) => {
  // define error message
  const [ errorMessage, setErrorMessage ] = useState('Please refresh the page.');
  const [ errorCode, setErrorCode ] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if(props){
      setErrorMessage(props.errorMessage || 'Please refresh the page.');
      setErrorCode(props.errorCode || '');
    }
  }, [props]);

  const goBack = () => {
    if(window.history.length > 0)
      window.history.back();
    else window.close();
  };

  const goToContactUs = () => {
    window.location = process.env.REACT_APP_WEB_URL
  };

  return(
    <div className="home-timesync">
      <div className="container loading-page" style={{ borderColor: `#${Colors.primaryColor}` }}>
        <div className="error-page">
            <div className="error-title">
              <span> { `Oops! ${t('Error')} ${ errorCode } ${t('occured')}!`} </span>
            </div>
            <div className="error-text">
              { t(`${errorMessage}`) }
            </div>

            <div className="button-actions">
              <button className="button-primary" onClick={() => goBack()}>{ t('Go Back') }</button>

              <button className="button-secondary button-right" onClick={() => goToContactUs()}>{ t('Contact Us') }</button>
            </div>
        </div>
      </div>
    </div>
  )
};

export default Error;